import { BorrowingPowerProductType, Query } from '@varo/graphql-schema-types';
import BorrowingPowerPage from 'services/graphql/queries/BorrowingPowerPage';
import { useQuery } from 'urql';

const useBorrowingPowerPage = (productType: BorrowingPowerProductType) => {
  const [{ data, error, fetching }, refetch] = useQuery<Query>({
    query: BorrowingPowerPage,
    variables: {
      input: {
        borrowingPowerProductType: productType,
      },
    },
    requestPolicy: 'cache-and-network',
  });

  return {
    borrowingPowerPage: data?.borrowingPowerPage,
    fetching,
    error,
    refetch,
  };
};

export default useBorrowingPowerPage;
